import { Guid, Nillable } from '@web/utils';
import { AdminProductStatus } from '../enums/admin-product-status';
import { Multimedia } from '@web/shared/module/multimedia';
import { AdminProductCharacteristicDetails } from './admin-product-characteristic-details';
import { AdminProductAttributeDetails } from './admin-product-attribute-details';

export class AdminProductDetails {
  public constructor(
    private readonly data: {
      canBeEdited: boolean;
      canBeRemoved: boolean;
      canBeViewed: boolean;
      cosmeticBrandId?: Nillable<Guid>;
      cosmeticBrandName?: Nillable<string>;
      characteristics?: Nillable<AdminProductCharacteristicDetails[]>;
      attributes?: Nillable<AdminProductAttributeDetails[]>;
      createdAt: Date;
      featuredFile?: Nillable<Multimedia>;
      files: Multimedia[];
      id: Guid;
      name: string;
      password?: Nillable<string>;
      price?: Nillable<number>;
      slug: string;
      status: AdminProductStatus;
      virtual: boolean;
      maxQuantityPerOrder: Nillable<number>;
      availableQuantity: Nillable<number>;
      warehouseProductName?: Nillable<string>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get password(): Nillable<string> {
    return this.data.password;
  }

  public get slug(): string {
    return this.data.slug;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get cosmeticBrandId(): Nillable<Guid> {
    return this.data.cosmeticBrandId;
  }

  public get cosmeticBrandName(): Nillable<string> {
    return this.data.cosmeticBrandName;
  }

  /* prettier-ignore */
  public get characteristics(): Nillable<AdminProductCharacteristicDetails[]> {
    return this.data.characteristics;
  }

  public get attributes(): Nillable<AdminProductAttributeDetails[]> {
    return this.data.attributes;
  }

  public get featuredFile(): Nillable<Multimedia> {
    return this.data.featuredFile;
  }

  public get price(): Nillable<number> {
    return this.data.price;
  }

  public get status(): AdminProductStatus {
    return this.data.status;
  }

  public get virtual(): boolean {
    return this.data.virtual;
  }

  public get maxQuantityPerOrder(): Nillable<number> {
    return this.data.maxQuantityPerOrder;
  }

  public get availableQuantity(): Nillable<number> {
    return this.data.availableQuantity;
  }

  public get warehouseProductName(): Nillable<string> {
    return this.data.warehouseProductName;
  }

  public get shopPreviewUrl(): Nillable<string> {
    return this.data.slug;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }

  public get files(): Multimedia[] {
    return this.data.files;
  }
}
